import React from 'react';
import { withStyles } from '@material-ui/core';
import Tooltip from '@material-ui/core/Tooltip';
import DeleteIcon from '@material-ui/icons/Delete';
import IconButton from '@material-ui/core/IconButton';
import clsx from 'clsx';

const styles = () => ({
    showDeleteButton: {
        visibility: 'visible',
    },
    hideDeleteButton: {
        visibility: 'hidden',
    },
    iconButton: {
        marginTop: '-12px',
        marginBottom: '-12px',
    },
});

class StepperDeleteIcon extends React.Component {
    render() {
        const { index, currStep, stepHoveredOver } = this.props;
        return (
            <Tooltip
                title="Delete"
                enterDelay={200}
                className={clsx({
                    [this.props.classes.showDeleteButton]: index === currStep || index === stepHoveredOver,
                    [this.props.classes.hideDeleteButton]: !(index === currStep || index === stepHoveredOver),
                })}
                disableFocusListener={true}
            >
                <IconButton
                    onClick={() => this.props.handleDeleteSection(index)}
                    className={this.props.classes.iconButton}
                    aria-label="Delete Section"
                >
                    <DeleteIcon color="action" />
                </IconButton>
            </Tooltip>
        );
    }
}

export default withStyles(styles)(StepperDeleteIcon);
